import { render, staticRenderFns } from "./BootstrapIconPicker.vue?vue&type=template&id=39688a11"
import script from "./BootstrapIconPicker.vue?vue&type=script&lang=js"
export * from "./BootstrapIconPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports